<template>
  <BaseSubHeading
    size="large"
    weight="600"
    class="t-short"
    :class="[
      `is_${size.toLowerCase()}`,
      {
        't-short__is-bordered': bordered || onlyLabel,
        't-short__is-selected': showTShirtSelected,
        'is-hovered': isHovered,
        'is-only-label': onlyLabel
      }
    ]"
  >
    <icon
      data="@icon/t-short.svg"
      :fill="true"
      width="var(--icon-32)"
      height="var(--icon-32)"
    />
    <span class="t-shirt__label">
      {{ label }}
    </span>

    <icon
      v-if="showTShirtSelected"
      data="@icon/check.svg"
      color="#4CAB26"
      width="var(--icon-24)"
      height="var(--icon-24)"
      :fill="true"
      class="t-short__selected-icon"
    />
  </BaseSubHeading>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

const components = {}

@Options({
  name: "TShortComponent",
  components
})
export default class TShortComponent extends Vue {
  @Prop({ default: "" }) readonly size: string
  @Prop({ default: "" }) readonly label: string
  @Prop({ default: false }) readonly bordered: boolean
  @Prop({ default: false }) readonly onlyLabel: boolean
  @Prop({ default: false }) readonly isHovered: boolean
  @Prop({ default: false }) readonly showTShirtSelected: boolean
}
</script>
